import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { OutboundLink } from 'gatsby-plugin-google-analytics'

import "./footer.css"

const Footer = () => {
  const {
    site: { buildTime },
  } = useStaticQuery(graphql`
    query {
      site {
        buildTime
      }
    }
  `)

  return (
    <footer>
      <div>
        <h2>Socials</h2>
        <div className="links">
          {/* Find me on: */}
          <OutboundLink href="https://www.linkedin.com/in/ste-baker-dev">LinkedIn</OutboundLink>{" "}|
          <OutboundLink href="https://github.com/stebaker92">GitHub</OutboundLink>{" "}
        </div>
      </div>

      <div className="container" hidden>
        © Steve Baker {new Date().getFullYear()}, Built using{` `}
        <a href="https://www.gatsbyjs.org">Gatsby</a>. Last updated on{" "}
        {/* Use build date at compile time */}
        {new Date(buildTime).toLocaleDateString("en-GB")}
        <div className="links">
          {/* Find me on: */}
          <OutboundLink href="https://www.linkedin.com/in/ste-baker-dev">LinkedIn</OutboundLink>{" "}|
          <OutboundLink href="https://github.com/stebaker92">GitHub</OutboundLink>{" "}|
          <OutboundLink href="https://dev.to/stebaker92">Dev.to</OutboundLink>{" "}
          {/* {" "}| <OutboundLink href="https://gitlab.com/stebaker92">GitLab</OutboundLink> */}
          {/* {" "}| <OutboundLink href="https://play.google.com/store/apps/developer?id=SteBakerDev">Play Store</OutboundLink> */}
        </div>
      </div>
    </footer>
  )
}

export default Footer
